<ng-container *ngIf="person$ | async as person">
    <div class="person-card-grid">
        <fa-icon [icon]="person.Deleted ? 'user-slash' : 'user'" class="image bigger"></fa-icon>

        <div class="content-main">
            <strong class="bigger">{{ person.DisplayName }}</strong>
            <span>{{ (personType$ | async)?.Name }}</span>
            <a class="link" *ngIf="person.Email as value" (click)="onOpenMailDialogClick(value); $event.stopPropagation();">
                {{ value }}
            </a>
        </div>

        <div class="content-side">
            <a class="link" *ngIf="person.PhoneNumber as value" [href]="'tel:' + value" (click)="$event.stopPropagation();">{{ value }}</a>
            <a class="link" *ngIf="person.MobileNumber as value" [href]="'tel:' + value" (click)="$event.stopPropagation();">{{ value }}</a>
        </div>

        <!-- MDQX: Notiz eines Ansprechpartners anzeigen. Dafür wurde die CSS Datei verändert -->
        <div class="content-bottom" >
            <div class="note" *ngIf="person.Description">{{ person.Description }}</div>
            <ng-content></ng-content>
        </div>
    </div>
</ng-container>
